import ImageBodyCopyFlexible from './component'
export default ImageBodyCopyFlexible
